import {
  FlexRow,
  formatHash,
  HashLength,
  NamedKeyPrefix,
  useMatchMedia,
} from '@make-software/cspr-ui';
import { HistoryLink } from '../history-link/history-link';
import React from 'react';
import { deriveSplitDataFromNamedKeyValue } from '../../domain';
import { useSearch } from '../../hooks/use-search';
import { buildRouterPath } from '../../router/utils';

interface NamedKeyValueProps {
  namedKey: string;
  noPrefix?: boolean;
  hashLength?: HashLength;
}

export const NamedKeyValue = ({
  namedKey,
  noPrefix,
  hashLength,
}: NamedKeyValueProps) => {
  const responsiveHashLength = useMatchMedia(
    [HashLength.TINY, HashLength.MEDIUM, HashLength.FULL, HashLength.FULL],
    []
  );
  const { prefix, hash, path } = deriveSplitDataFromNamedKeyValue(namedKey);

  const isHashWithoutPrefix = !prefix;
  const { data: dataForHashWithoutPrefix, error } = useSearch(
    isHashWithoutPrefix ? hash : null
  );

  const isURefNamedKey = namedKey.includes(NamedKeyPrefix.UREF);
  const redirectHash = isURefNamedKey ? namedKey : hash;

  const redirectPath =
    dataForHashWithoutPrefix && !error
      ? `/${dataForHashWithoutPrefix.type}/${dataForHashWithoutPrefix.hash}`
      : path
        ? buildRouterPath(path, { id: redirectHash }, undefined)
        : '';
  return (
    <FlexRow>
      {redirectPath ? (
        <HistoryLink href={redirectPath}>
          {!noPrefix && prefix}
          {formatHash(hash, hashLength || responsiveHashLength)}
        </HistoryLink>
      ) : (
        formatHash(hash, hashLength || responsiveHashLength)
      )}
    </FlexRow>
  );
};

export default NamedKeyValue;
